/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

var ItemsType = /* @__PURE__ */function (ItemsType2) {
  ItemsType2["props"] = "props";
  ItemsType2["slots"] = "slots";
  return ItemsType2;
}(ItemsType || {});

export { ItemsType };
//# sourceMappingURL=interface.mjs.map
